import {Trans} from '@common/i18n/trans';
import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {closeDialog, openDialog} from '@common/ui/overlays/store/dialog-store';
import {
  useGetProfiles,
  useSelectProfile,
} from './profile/requests/use-get-profiles';
import {AccountCircleIcon} from '@common/icons/material/AccountCircle';

function SelectProfileDialog() {
  const getProfiles = useGetProfiles();
  const selectProfile = useSelectProfile();

  return (
    <Dialog>
      <DialogHeader
        onDismiss={() => {
          closeDialog(SelectProfileDialog);
        }}
      >
        <span className="text-base">
          <Trans message="Select Profile" />
        </span>
      </DialogHeader>
      <DialogBody className="w-full">
        <div className="max-w-full">
          <span className="text-base">
            <Trans message="Who is watching?" />
          </span>
          <div className="flex items-center justify-center gap-[50px] py-[30px]">
            {getProfiles?.data?.map(item => (
              <div
                className="relative flex cursor-pointer flex-col items-center gap-14"
                onClick={() =>
                  selectProfile.mutate(item.id, {
                    onSuccess: () => {
                      closeDialog(SelectProfileDialog);
                    },
                  })
                }
              >
                {item.avatar ? (
                  <img
                    className="h-[100px] w-[100px] rounded-full"
                    src={item?.avatar?.url}
                    alt=""
                  />
                ) : (
                  <AccountCircleIcon className="h-[100px] w-[100px]" />
                )}
                <span className={`text-xl text-white max-md:text-base`}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
}

export default SelectProfileDialog;
